import Button from '@material-ui/core/Button';
import styled from 'styled-components';

export default styled(Button)`
  && {
    text-transform: initial;
  }
`;
